/** api/squadTemplates.js — templates de squads (Bloco 6). */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from './client';

export function useSquadTemplates() {
  const api = useApi();
  return useQuery({ queryKey: ['squad-templates'], queryFn: () => api.get('/squad-templates') });
}

export function useCreateSquadTemplate() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/squad-templates', body),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['squad-templates'] }),
  });
}

export function useUseSquadTemplate() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.post(`/squad-templates/${id}/use`, {}),
    onSuccess:  () => qc.invalidateQueries({ queryKey: ['squad-templates'] }),
  });
}
